import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
  SharedFormRow,
  SharedFormColumn,
} from "../../../components/layout/SharedFormElements/SharedFormRowAndColumns";
import ParentCompanyDropdown from "../sharedAdminComponents/ParentCompanyDropdown";
import LocationDropdown from "../sharedAdminComponents/LocationDropdown";
import PayerDropdown from "../sharedAdminComponents/PayerDropdown";
import { useAdminComponentsData } from "../sharedAdminComponents/hooks/useAdminComponentsData";

export default function AdminMissingRemittanceForm(props) {
  const { handleFormSubmit } = props;

  // Use the consolidated admin components data hook
  const {
    selectedPayers,
    selectedParentCompany,
    selectedLocations,
    setSelectedPayers,
    setSelectedParentCompany,
    setSelectedLocations,
  } = useAdminComponentsData();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [checkNumber, setCheckNumber] = useState("");
  const [mpid, setMpid] = useState("");
  function submitForm() {
    let parameters = {
      toDate: toDate,
      fromDate: fromDate,
      checkNumber: checkNumber,
      selectedPayer: selectedPayers,
      selectedParentCompany: selectedParentCompany,
      selectedLocation: selectedLocations,
      mpid: mpid,
    };
    let validationIssueMessage = ValidationMessage();

    if (validationIssueMessage) {
      alert(validationIssueMessage);
    } else {
      handleFormSubmit(parameters);
    }
  }

  function ValidationMessage() {
    if (checkNumber === "") {
      if (fromDate === "" || toDate === "") {
        return "Please enter start and end date.";
      }
      var startDateval = new Date(fromDate);
      var endDateval = new Date(toDate);
      if (startDateval > endDateval) {
        return "Start date should not greater than end date.";
      }

      var differentTime = endDateval.getTime() - startDateval.getTime();
      var differentDays = differentTime / (1000 * 60 * 60 * 24);
      if (differentDays > 365 * 2) {
        return "Date range should not be more than 2 years.";
      }
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    submitForm();
  }

  function clearform() {
    setFromDate("");
    setToDate("");
    setSelectedParentCompany("");
    setSelectedPayers([]);
    setCheckNumber("");
    setMpid("");
    setSelectedLocations([]);
  }

  function resetOnClick() {
    clearform();
    props.handleFormReset();
  }
  return (
    <Form onSubmit={handleSubmit}>
      <SharedFormRow>
        <SharedFormColumn>
          <Form.Label>Parent Company</Form.Label>
          <Form.Control
            as={ParentCompanyDropdown}
            selectedParentCompany={selectedParentCompany}
            setSelectedParentCompany={setSelectedParentCompany}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>Payer</Form.Label>
          <Form.Control
            as={PayerDropdown}
            selectedPayer={selectedPayers}
            setSelectedPayer={setSelectedPayers}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            name="fromDate"
            as={DatePicker}
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>End Date</Form.Label>
          <Form.Control
            name="toDate"
            as={DatePicker}
            selected={toDate}
            onChange={(date) => setToDate(date)}
          />
        </SharedFormColumn>
      </SharedFormRow>
      <SharedFormRow>
        <SharedFormColumn>
          <Form.Label>Location (NCPDP)</Form.Label>
          <Form.Control
            as={LocationDropdown}
            selectedParentCompany={selectedParentCompany}
            selectedLocations={selectedLocations}
            setSelectedLocations={setSelectedLocations}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>MPID</Form.Label>
          <Form.Control
            type="text"
            placeholder=""
            onChange={(e) => {
              setMpid(e.target.value);
            }}
            value={mpid}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Form.Label>Check Number</Form.Label>
          <Form.Control
            type="text"
            placeholder=""
            onChange={(e) => {
              setCheckNumber(e.target.value);
            }}
            value={checkNumber}
          />
        </SharedFormColumn>
        <SharedFormColumn>
          <Button className="inline-show-result-button" size="sm" type="submit">
            Show Results
          </Button>
        </SharedFormColumn>
        <SharedFormColumn>
          <Button
            className="inline-show-result-button"
            size="sm"
            type="button"
            onClick={resetOnClick}
          >
            Reset
          </Button>
        </SharedFormColumn>
      </SharedFormRow>
    </Form>
  );
}
